import { DtoolsAuthDetails, DtoolsConnectionStatus } from 'src/gql/graphql';

export { DtoolsConnectionStatus };

export type DtoolsAuthDetailsParams = {
  partnerId: number;
};

export type DtoolsAuthDetailsInput = {
  params: DtoolsAuthDetailsParams;
};

export type DtoolsAuthResponse = {
  getDtoolsAuthDetails: {
    authDetails: Pick<DtoolsAuthDetails, 'id' | 'status'> | null;
  };
};

export type DtoolsAuthDetail = Pick<
  DtoolsAuthDetails,
  'partnerId' | 'maskedApiKey' | 'status' | 'lastValidatedAt'
>;

/*
 * A stored key is only a usable connection while D-Tools still accepts it, so consumers ask this
 * rather than testing for the presence of a record.
 */
export function isDtoolsConnected(
  authDetails?: Pick<DtoolsAuthDetail, 'status'> | null,
): boolean {
  return !!authDetails && authDetails.status !== DtoolsConnectionStatus.Invalid;
}

export type DtoolsProjectDetailsResponse = {
  getDtoolsProjectDetails: {
    content: string;
  };
};
